var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddcircleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1567 0C4.63374 0 0.156738 4.477 0.156738 10C0.156738 15.523 4.63374 20 10.1567 20C15.6797 20 20.1567 15.523 20.1567 10C20.1567 4.477 15.6797 0 10.1567 0ZM15.1567 11H11.1567V15H9.15674V11H5.15674V9H9.15674V5H11.1567V9H15.1567V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcircleicon);
export default __webpack_public_path__ + "static/media/addcircleicon.34483e26f70e0bff2370e7f04f70cc75.svg";
export { ForwardRef as ReactComponent };